export default __webpack_public_path__ + "44b53ea381558eaf702a103c24b9f3e2.svg";